var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('insurance-table',{attrs:{"site-id":_vm.rowData.id,"cient-site-id":_vm.rowData.siteId,"read-only":_vm.readOnly,"site-name":_vm.rowData.siteName}})}
var staticRenderFns = []

export { render, staticRenderFns }